import * as React from 'react';

import { Direction } from '~shared/utils/sort';

export enum QuizListColumn {
  Title = 'Title',
  Owner = 'Owner',
  Modified = 'Modified',
}

type Sort = {
  quizListColumn: QuizListColumn;
  direction: Direction;
};

type NoSort = {
  quizListColumn: null;
  direction: null;
};

export type ColumnSortState = Sort | NoSort;
export type DispatchColumnSortAction = React.Dispatch<ColumnSortAction>;

type ResetAction = {
  type: 'Reset';
};

type ToggleColumnAction = {
  type: 'ToggleColumn';
  quizListColumn: QuizListColumn;
};

export type ColumnSortAction = ResetAction | ToggleColumnAction;

function columnSortReducer(state: ColumnSortState, action: ColumnSortAction) {
  switch (action.type) {
    case 'Reset':
      return {
        quizListColumn: null,
        direction: null,
      };
    case 'ToggleColumn':
      return {
        quizListColumn: action.quizListColumn,
        direction:
          state.quizListColumn !== action.quizListColumn
            ? Direction.Descending
            : state.direction === Direction.Descending
            ? Direction.Ascending
            : Direction.Descending,
      };
  }
  return state;
}

const initializer = ({ quizListColumn: column, direction }: ColumnSortState) =>
  column && direction
    ? {
        quizListColumn: column,
        direction: direction,
      }
    : {
        quizListColumn: null,
        direction: null,
      };

interface UseColumnSortReducerParams {
  initialSortColumn?: QuizListColumn;
  initialSortDirection?: Direction;
}
export const useColumnSortReducer = (
  { initialSortColumn, initialSortDirection }: UseColumnSortReducerParams = {
    initialSortColumn: QuizListColumn.Modified,
    initialSortDirection: Direction.Descending,
  }
) =>
  React.useReducer(
    columnSortReducer,
    { quizListColumn: initialSortColumn, direction: initialSortDirection },
    initializer
  );
